import axios from 'axios'

export default {
  state: {
    orgData_is_change:'1',
    orgData: '',
    orgSimpleData: '',
    projectData: '',
    projectChidlData: '',
    orgId: '',
    projectId: '',
    projectChildId: '',
    orgNoAllData: '',
    employeeinformcurrentIndex: 1,
    userData: sessionStorage.getItem("userData"),
    cmsCustomerList: '',
    sysProjectList: '',
    organizationDataList: [],//组织DATA
    customerDataTreeOption: [],//客户信息 级联
    sysUserList: [],//系统的用户列表
    sysProjectAllDataList: '',//所有系统的分部和项目部信息
    projectTypeList: '',//客户类型
    customerAttributeList: [],//客户属性
    orgDataGTF: '',
    orgDataByDataRight: '',//根据数据权限查询的机构

  },
  mutations: {
    changeEmployeeinformcurrentIndex(state, pageval) {
      state.employeeinformcurrentIndex = pageval;
    },

    findSysOrg(state, orgData) {
      state.orgData = orgData
    },
    findSysOrgGTF(state, data) {
      state.orgDataGTF = data
    },
    findSysOrgByDataRight(state, data) {
      state.orgDataByDataRight = data
    },
    findSysSimpleOrg(state, orgData) {
      state.orgSimpleData = orgData
    },
    findCmsCustomerList(state, data) {
      state.cmsCustomerList = data
    },
    findSysProject(state, data) {
      state.sysProjectList = data
    },
    findOrganizationInfoList(state, data) {
      state.organizationDataList = data;
    },
    initCustomerInfoCascader(state, data) {
      state.customerDataTreeOption = data;

    },
    findSysUserList(state, data) {
      state.sysUserList = data;

    },

    getHeight(state) {
      let tableHeight = document.getElementById("table").offsetHeight;
      let computeHeight = document.body.clientHeight - document.getElementById("table").offsetTop - 110;
      alert('tableHeight' + tableHeight + "." + 'computeHeight' + computeHeight + "." + document.body.clientHeight + "." + document.getElementById("table").offsetTop)
      if (tableHeight < computeHeight) {
        state.height = null;
      } else {
        state.height = computeHeight;
      }
    },
    findSysProjectAll(state, data) {
      state.sysProjectAllDataList = data;

    },
    findProjectTypeList(state, data) {
      state.projectTypeList = data;

    },
    findCustomerAttributeList(state, data){
      state.customerAttributeList = data;
    },
  },
  actions: {
    cleanfindSysOrg(context) {
      axios.post('home/findSysOrgFaster', {'is_audit_success': 1}).then(res => {
        if (!res.data) { //?
          return;
        }
        this.state.orgData_is_change = '0';
        context.commit('findSysOrg', res.data.message)
      })
    },//清除机构

    findSysOrg(context) {
      if (!context.state.orgData) {
        axios.post('home/findSysOrgFaster', {'is_audit_success': 1}).then(res => {
          if (!res.data) { //?
            return;
          }
          this.state.orgData_is_change = '0';
          context.commit('findSysOrg', res.data.message)
        })
      }
    },//查找机构

    findSysOrgGTF(context) {
      if (!context.state.orgDataGTF) {
        axios.post('home/findSysOrgGTF').then(res => {
          context.commit('findSysOrgGTF', res.data.message)
        })
      }
    },//查找机构

    findSysOrgByDataRight(context) {
      if (!context.state.orgDataByDataRight) {
        axios.post('home/findSysOrgByDataRight').then(res => {
          context.commit('findSysOrgByDataRight', res.data.message)
        })
      }
    },//查找机构

    findSysSimpleOrg(context) {
      if (!context.state.orgSimpleData) {
        axios.post('home/findSysOrgFaster').then(res => {
          if (!res.data) { //?
            return;
          }
          context.commit('findSysSimpleOrg', res.data.message)
        })
      }
    },//查找机构

    // findSysOrg2({commit}){
    //   axios.post(context.state.url+'home/findSysOrg').then(res=>{
    //     context.commit('findSysOrg',res.data.message)
    //   })
    // },//查找机构
    findSysProject(context) {
      axios.post('home/findSysProject').then(res => {
        context.commit('findSysProject', res.data.message)
      })
    },//查找机构
    findCmsCustomerList(context) {
      axios.post('home/findCmsCustomerList').then(res => {
        context.commit('findCmsCustomerList', res.data.message)
      })
    },//查看业务系统客户

    findSysUserList(context) {
      axios.post('home/findUserList', { 'is_enable': 1 }).then(res => {
        context.commit('findSysUserList', res.data.message)
      })
    },//查找系统的用户列表

    findOrganizationInfoList(context) {

      if (context.state.organizationDataList == '') {
        axios.post("home/findOrganizationInfoList").then(
          res => {
            context.commit('findOrganizationInfoList', res.data.message)
          },

        );
      }
    }, //查找组织信息

    findSysProjectAll(context) {

      if (context.state.sysProjectAllDataList =='') {
        let params = {

        }
        axios.post('home/findSysProjectAll', params).then(res => {
          context.commit('findSysProjectAll', res.data.message)
        }, (res => {
        }))
      }

    },//

    initCustomerInfoCascader(context) {
      if (context.state.customerDataTreeOption == '') {
        axios.post("home/initCustomerInfoCascader").then(res => {
          context.commit('initCustomerInfoCascader', res.data.message)
        });
      }
    }, //查询客户信息 用于级联组件
    findProjectTypeList(context) {
      if (context.state.projectTypeList=='') {
        axios.post("home/findDropDownListByTableNameAndFieldName", {
          table_name: "ALL_TABLE",
          field_name: "project_type"
        }).then(res => {
          context.commit('findProjectTypeList', res.data)
        });
      }
    },
    findCustomerAttributeList(context){
      if (context.state.customerAttributeList=='') {
        axios.post("home/findDropDownListByTableNameAndFieldName", {
          table_name: "SYS_PROJECT",
          field_name: "customer_attribute"
        }).then(res => {
          context.commit('findCustomerAttributeList', res.data)
        });
      }
    },




  }
}



// WEBPACK FOOTER //
// ./src/vuex/userinfo.js